import React, { Component, Fragment } from "react";
import {
  Row,
    Col,
  Container
} from "reactstrap";
import "./Site.css";
import "react-datepicker/dist/react-datepicker.css";
import { Bar } from "react-chartjs-2";
import _ from "lodash";

const formatData = (
  data,
  xAxisLabels,
  label,
  hoverBorderColor,
  borderColor
) => {
  const formattedData = {
    labels: xAxisLabels,
    datasets: [{
      data: data,
      backgroundColor: hoverBorderColor,
      borderColor: borderColor
    }]
  }
  return formattedData;
};

const formatMultiLineData = (
  dataList,
  xAxisLabels,
  labels,
  hoverBorderColor,
  borderColors
) => {
  var multiLineData = _.map(dataList, (d, index) => {
    var data = {
      data: d.data,
      label: !xAxisLabels
        ? d.name
        : _.find(xAxisLabels, (l, idx) => {
          return idx === index;
        }),
      borderColor: _.find(borderColors, (bc, idx) => {
        return idx === index;
      }),
      backgroundColor: _.find(hoverBorderColor, (h, idx) => {
        return idx === index;
      })
    };
    return data;
  });
  var shapedData = {
    labels: labels,
    datasets: multiLineData
  };
  return shapedData;
};

export default class BarChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
    //  data: this.props.isMultiLine
    //    ? formatMultiLineData(
    //      this.props.data,
    //      this.props.xAxisLabels,
    //      this.props.label,
    //      this.props.hoverBorderColor,
    //      this.props.borderColor
    //    )
    //    : formatData(
    //      this.props.data,
    //      this.props.xAxisLabels,
    //      this.props.label,
    //      this.props.hoverBorderColor,
    //      this.props.borderColor
    //    )
    };
  }

  render() {
    //console.log(
    //"PROPS",
    //  this.props.data,
    //  this.props.xAxisLabels,
    //  this.props.label,
    //  this.props.hoverBorderColor,
    //  this.props.borderColor
    //)
    const data = {
      labels: this.props.xAxisLabels, 
      datasets: [{
        label: this.props.label,
        data: this.props.data,
        backgroundColor: this.props.hoverBorderColor, 
        borderColor: this.props.borderColor 
      }]
      }
      return (
          <Fragment>
              {data &&
                  <div className={`${data && data.datasets && data.datasets.length > 57 && "pl-4 pr-4"}`}
                      style={{
                          maxWidth: "1500px",
                          overflowY: "visible",
                          overflowX: "scroll",
                      }}
                  >
                      <Bar
                          data={data}
                          options={{
                              responsive: true,
                              maintainAspectRatio: true,
                              layout: {
                                  padding: {
                                      left: this.props.leftPadding ? this.props.leftPadding : 0,//50
                                      right: this.props.rightPadding ? this.props.rightPadding : 0,
                                      top: 0,
                                      bottom: 0
                                  },
                              },
                              title: {
                                  display: this.props.display,
                                  text: this.props.text
                              }
                          }}

                      />
                  </div>
              }
          </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/BarChart.js